<!--
Copyright 2021 Carnegie Mellon University. All Rights Reserved.
Released under a MIT (SEI)-style license. See LICENSE.md in the project root for license information.
-->

<div class="content">
  <div class="content">
    <h1 mat-dialog-title>Add VM Credentials</h1>
    <mat-form-field class="param-full-width">
      <mat-label>Username</mat-label>
      <input
        matInput
        placeholder="Username"
        [(ngModel)]="data.vmCredential.username"
        tabindex="1"
      />
    </mat-form-field>
    <mat-form-field class="param-full-width">
      <mat-label>Password</mat-label>
      <input
        matInput
        [type]="'password'"
        placeholder="Password"
        [(ngModel)]="data.vmCredential.password"
        tabindex="2"
      />
    </mat-form-field>
    <mat-form-field class="param-full-width">
      <mat-label>Description</mat-label>
      <input
        matInput
        placeholder="Description"
        [(ngModel)]="data.vmCredential.description"
        tabindex="3"
      />
    </mat-form-field>
  </div>
  <div>
    <div>
      <button mat-stroked-button (click)="onClick(true)" tabindex="4">
        ADD
      </button>
    </div>
    <div>
      <button mat-stroked-button (click)="onClick(false)" tabIndex="5">
        CANCEL
      </button>
    </div>
  </div>
</div>
